"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "altavalle": {
    "100707e9": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "skipSearch": false
    }],
    "ferrai": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d9475735": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "skipSearch": false
    }],
    "gaiardi": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d1bab1ff": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "skipSearch": false
    }],
    "la-rio": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4dc3880": [{
      "hkey": "42dcd6f1",
      "slug": "maso-greggion",
      "name": "Maso Greggion",
      "primary": true,
      "skipSearch": false
    }],
    "masi-greggion": [{
      "hkey": "42dcd6f1",
      "slug": "maso-greggion",
      "name": "Maso Greggion",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8f2477a6": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "skipSearch": false
    }],
    "noldi": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "84080347": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "skipSearch": false
    }],
    "orion": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9a156d77": [{
      "hkey": "b382b92f",
      "slug": "maso-pinteri",
      "name": "Maso Pinteri",
      "primary": true,
      "skipSearch": false
    }],
    "pinteri": [{
      "hkey": "b382b92f",
      "slug": "maso-pinteri",
      "name": "Maso Pinteri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7bea1f02": [{
      "hkey": "41b1f0a9",
      "slug": "maso-pojeri",
      "name": "Maso Pojeri",
      "primary": true,
      "skipSearch": false
    }],
    "pojeri": [{
      "hkey": "41b1f0a9",
      "slug": "maso-pojeri",
      "name": "Maso Pojeri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4c397f21": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "skipSearch": false
    }],
    "portegnago": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6f7b85d5": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "skipSearch": false
    }],
    "rella": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ada15a37": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "skipSearch": false
    }],
    "rosa": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2568591a": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "skipSearch": false
    }],
    "todescatt": [{
      "hkey": "5052c01e",
      "slug": "altavalle",
      "name": "Altavalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;